<template>
  <div>
    <div class="myorder">
      <div class="app-top-nav">
        <router-link :to="{ name: 'myorder', query: { status: 0 }}" :class="[status==0?'cur':'']" replace>待处理</router-link>
        <router-link :to="{ name: 'myorder', query: { status: 1 }}" :class="[status==1?'cur':'']" replace>服务中</router-link>
        <router-link :to="{ name: 'myorder', query: { status: 2 }}" :class="[status==2?'cur':'']" replace>待取件</router-link>
        <router-link :to="{ name: 'myorder', query: { status: 3 }}" :class="[status==3?'cur':'']" replace>待评价</router-link>
        <router-link :to="{ name: 'myorder', query: { status: 4 }}" :class="[status==4?'cur':'']" replace>已完成</router-link>
        <router-link :to="{ name: 'myorder', query: { status: -1 }}" :class="[status==-1?'cur':'']" replace>全部</router-link>
      </div>
      <div v-if="list.length > 0" class="list">
        <div v-for="(v,k) in list" v-bind:key="k" class="item">
          <div @click="info(v)" class="sitem topline">
            <span class="tit">订单号：{{v.oid}}</span>
            <span v-if="v.status==0" class="status">待处理</span>
            <span v-if="v.status==1" class="status">服务中</span>
            <span v-if="v.status==2" class="status">待取件</span>
            <span v-if="v.status==3" class="status">待评价</span>
            <span v-if="v.status==4" class="status">已完成</span>
            <span v-if="v.status==5" class="status">已取消</span>
          </div>
          <div @click="info(v)" class="sitem topline">
            <div class="ovh">
              <div class="name storename fl">店名：{{v.store}}</div>
              <!-- <div class="name fr">店员：衣印</div> -->
            </div>

            <p class="time">送洗时间：{{v.created_at}}</p>
          </div>

          <div @click="info(v)" v-for="(nv,nk) in v.noteArr" v-bind:key="nk" class="sitem sitem2 topline">
            <p v-for="(item,key) in cloth" v-bind:key="key" v-if="nv[key]">
              {{item}}：<span>{{key=='clothesssje'?nv[key].toFixed(2):nv[key]}}</span>
            </p>
            <!-- <p v-for="(item,key) in cloth2" v-bind:key="key" v-if="nv[key]">
              {{item}}：<span>{{nv[key]}}</span>
            </p> -->
          </div>
          <div @click="info(v)" class="total sitem  topline bottomline">
            <div class="ovh">
              <p class="fl">衣物件数：<span>{{v.clothNum}}件</span></p>
              <p>支付状态：<span>{{v.pay_status == 1?'已支付':'未支付'}}</span></p>
              <p v-if="v.pay_status == 1" class="fr">支付方式：
                <span v-for="(m,n) in payTypeList" v-if="v.pay_type==m.id">{{m.title}}支付</span>
              </p>
            </div>

            <div class="ovh df jcsb">
              <!-- <p>合计金额：<span class="snum">{{v.cost_price}}</span>元</p> -->
              <p>优惠金额：<span class="snum">{{Math.round((v.cost_price-v.price) * 100) / 100}}</span>元</p>
              <p>实付金额：<span class="snum">{{v.price}}</span>元</p>
            </div>

          </div>

          <div v-if="v.status==0 || v.status==2 || v.status==3 || v.status==4" class="operation sitem bottomline ovh">
            <span @click="info(v)" v-if="v.check" class="btn ml10">去处理</span>
            <span @click="info(v)" v-if="v.status==2" class="btn">确认收货</span>
            <span @click="info(v)" v-if="v.status==3" class="btn">评价</span>
            <span @click="info(v)" v-if="v.status==4" class="btn">查看评价</span>
            <span @click="link('recharge')" v-if="v.recharge" class="btn ml10">去充值</span>
          </div>
        </div>
      </div>
      <div v-else class="nodata">暂无数据</div>

      <div v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10"></div>
    </div>
    <div class="weui-loadmore" v-if="load">
      <i class="weui-loading"></i>
      <span class="weui-loadmore__tips">正在加载</span>
    </div>
  </div>
</template>

<script>
import infiniteScroll from '@/basic/infiniteScroll'
export default {
  directives: { infiniteScroll },
  props: {
    islogin: Boolean,
  },
  data() {
    return {
      payTypeList: [
        { id: 0, title: '余额' },
        { id: 1, title: '单位余额' },
        { id: 2, title: '门店' },
        { id: 3, title: '现金' },
        { id: 4, title: '信用卡' },
        { id: 5, title: '储值卡' },
        { id: 6, title: '微信' },
        { id: 7, title: '支付宝' },
        { id: 8, title: '公众号' },
        { id: 9, title: '主钱包' },
        { id: 10, title: '钱包3' }
      ],
      cloth: {
        "clothesno": "衣物编号",
        "clothesname": "衣物名称",
        "clothescolor": "颜色",
        "washtype": "洗涤方式",
        "clothesje": "金额",
        "clothesssje": "实收金额",
        "brand": "衣物品牌",
        "clothesstatus": "衣物状态",
        "attachment": "衣物附件",
        "note": "备注",
        "requirement": "客人要求",
        "additional": "附加要求",
        "additional_price": "附加价格"
      },
      cloth2: {
        "clothesstatus": "衣物状态",
        "attachment": "衣物附件",
        "note": "备注",
        "requirement": "客人要求",
        "additional": "附加要求",
        "additional_price": "附加价格"
      },
      list: [],
      busy: true,
      load: true,
      page: 1,
      status: -1
    }
  },
  created() {
    this.status = this.$route.query.status;
    if (this.islogin == true) {
      this.getAccountOrder();
    }
  },
  watch: {
    'islogin'() {
      console.log('????')
      if (this.islogin == true) {
        this.getAccountOrder();
      }
    },
    "$route"(newVal, oldVal) {
      this.page = 1;
      this.status = newVal.query.status;
      this.getAccountOrder();
    }
  },
  methods: {
    info(v) {
      let vm = this;
      vm.$router.push({ name: 'orderinfo', query: { oid: v.oid } });
    },
    link(name) {
      let vm = this;
      vm.$router.push({ name: name });
    },
    getAccountOrder(flag) {
      let vm = this;
      let str = 'page=' + vm.page;
      if (vm.status >= 0) {
        str += '&status=' + vm.status;
      }
      vm.ajax("account/order", "get", str, e => {
        vm.load = false;
        if (e.data.list) {
          let list = e.data.list;
          list.map((v, k) => {
            v.clothNum = 0;
            if (v.note) {
              try {
                v.noteArr = JSON.parse(v.note);
                v.clothNum = v.noteArr.length;
              } catch (error) {

              }
            }
          })
          if (flag) {
            vm.list = vm.list.concat(list)
            if (e.data.count == vm.page) {
              vm.busy = true;
            } else {
              vm.busy = false;
            }
          } else {
            // console.log('222')
            vm.list = list;
            if (vm.list.length < e.data.limit) {
              vm.busy = true;
            } else {
              vm.busy = false;
            }
          }
        } else {
          if (!flag) {
            vm.list = [];
          }
          vm.busy = true;
        }
      })
    },
    loadMore() {
      let vm = this;
      vm.busy = true;
      vm.load = true;
      setTimeout(() => {
        vm.page++;
        vm.getAccountOrder(true);
      }, 1000);
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/myorder.vue